let SQLite = null
try {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const { Platform } = require('react-native')
    if (Platform?.OS !== 'web') {
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        SQLite = require('expo-sqlite')
    }
} catch {}
import { isWeb, getPlatform } from '../src/utils/platformUtils'
let __dbModule = null
const buildLocalWrappedDb = () => {
    try {
    if (!SQLite) throw new Error('SQLite not available (web)')
    const localDb = SQLite.openDatabaseSync('myDB')
        if (getPlatform().OS === 'android') {
            try { localDb.execSync('PRAGMA journal_mode = WAL;') } catch {}
        }
        const wrapStatement = (stmt) => ({
            executeSync: (params = []) => {
                const res = stmt.executeSync(params)
                const rowsArray = Array.isArray(res?.rows) ? res.rows : Array.isArray(res?.rows?._array) ? res.rows._array : []
                return {
                    ...res,
                    getAllSync: () => rowsArray,
                    getFirstSync: () => (rowsArray && rowsArray.length ? rowsArray[0] : null),
                }
            },
            finalizeSync: () => stmt.finalizeSync(),
        })
        return {
            execSync: (sql) => localDb.execSync(sql),
            prepareSync: (sql) => {
                const stmt = localDb.prepareSync(sql)
                const wrapped = wrapStatement(stmt)
                return {
                    executeSync: wrapped.executeSync,
                    finalizeSync: wrapped.finalizeSync,
                    getAllSync: (params = []) => wrapped.executeSync(params).getAllSync(),
                    getFirstSync: (params = []) => wrapped.executeSync(params).getFirstSync(),
                }
            },
        }
    } catch (e) {
        console.error('Fallback SQLite wrapper (gamification) failed:', e)
        return null
    }
}
const getWrappedDB = () => {
    if (!__dbModule) {
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        __dbModule = require('../src/db/indexDB')
    }
    const fromIndex = __dbModule?.getNativeDB ? __dbModule.getNativeDB() : null
    return fromIndex || buildLocalWrappedDb()
}
import { GAMIFICATION_STORE_NAMES } from '../src/db/constants'

// Exportar GAMIFICATION_STORE_NAMES para uso en otros archivos
export { GAMIFICATION_STORE_NAMES }

const database = 'myDB'

let instance = null

const openDatabase = () => {
    if (instance) return instance
    if (isWeb()) {
        // En web los métodos manejarán su propia lógica (IDB o no-op). Devolvemos un stub seguro.
        instance = {
            transaction: () => ({ executeSql: () => {} }),
        }
        return instance
    }

    const dbSync = getWrappedDB()

    const facade = {
        execSync: (sql) => dbSync.execSync(sql),
        prepareSync: (sql) => dbSync.prepareSync(sql),
        transaction: (callback, errorCallback, successCallback) => {
            try {
                const tx = {
                    executeSql: (sql, params = [], success, error) => {
                        try {
                            const isSelect = /^\s*SELECT/i.test(sql)
                            if (isSelect) {
                                const stmt = dbSync.prepareSync(sql)
                                const rowsArray = stmt.getAllSync(params)
                                stmt.finalizeSync()
                                const rows = {
                                    length: rowsArray.length,
                                    item: (i) => rowsArray[i],
                                    _array: rowsArray,
                                }
                                const result = { rows, rowsAffected: 0, insertId: undefined }
                                success && success(tx, result)
                            } else {
                                const stmt = dbSync.prepareSync(sql)
                                stmt.executeSync(params)
                                stmt.finalizeSync()
                                const changes = dbSync.prepareSync('SELECT changes() as rowsAffected').getFirstSync()
                                const lastId = /\bINSERT\b/i.test(sql)
                                    ? dbSync.prepareSync('SELECT last_insert_rowid() as insertId').getFirstSync()
                                    : { insertId: undefined }
                                const result = {
                                    rows: { length: 0, item: () => undefined, _array: [] },
                                    rowsAffected: changes?.rowsAffected ?? 0,
                                    insertId: lastId?.insertId,
                                }
                                success && success(tx, result)
                            }
                        } catch (e) {
                            if (error) return error(tx, e)
                            throw e
                        }
                    },
                }
                callback && callback(tx)
                successCallback && successCallback()
            } catch (e) {
                errorCallback && errorCallback(e)
            }
        },
    }

    instance = facade
    return instance
}

export const db = openDatabase()

class gamificationServices {
    constructor() {
        this.db = db
    }

    saveGame = async (game_id, level_id, status, body) => {
        // En web no persistimos juegos pendientes (no hay store dedicado). Salida segura.
        if (isWeb()) {
            return Promise.resolve(null)
        }
        const db = openDatabase()
        return new Promise((resolve, reject) => {
            db.transaction(
                (tx) => {
                    const query = `INSERT OR REPLACE INTO ${GAMIFICATION_STORE_NAMES.GAME_PENDING_SEND} (game_id, level_id, status, body) VALUES (?, ?, ?, ?)`
                    const newBody = JSON.stringify(body)
                    tx.executeSql(
                        query,
                        [game_id, level_id, status, newBody],
                        (_, result) => {
                            if (result.rows.length > 0) {
                                let savedGames = result.rows.item(0)
                                console.log('Saved game:', JSON.stringify(savedGames))
                                resolve(savedGames)
                            } else {
                                console.log('RESULT', JSON.stringify(result))
                                resolve(null)
                            }
                        },
                        (_, error) => {
                            console.error('Error al guardar las respuestas', error)
                            reject(error)
                        },
                    )
                },
                (error) => {
                    console.error('Transaction error:', error)
                    reject(error)
                },
            )
        })
    }
    getPendingGames = async () => {
        if (isWeb()) {
            return Promise.resolve([])
        }
        const db = openDatabase()
        return new Promise((resolve, reject) => {
            db.transaction(
                (tx) => {
                    const query = `SELECT * from ${GAMIFICATION_STORE_NAMES.GAME_PENDING_SEND} ORDER BY _id ASC`
                    tx.executeSql(
                        query,
                        [],
                        (_, result) => {
                            if (result.rows.length > 0) {
                                let pendingGames = result.rows._array
                                console.log('Recovered games:', JSON.stringify(pendingGames))
                                resolve(pendingGames)
                            } else {
                                console.log('No se encontraron Games pendientes de envío', JSON.stringify(result))
                                resolve(null)
                            }
                        },
                        (_, error) => {
                            console.error('Error al obtener las respuestas', error)
                            reject(error)
                        },
                    )
                },
                (error) => {
                    console.error('Transaction error:', error)
                    reject(error)
                },
            )
        })
    }
    deleteGameById = async (game_id, level_id) => {
        if (isWeb()) {
            return Promise.resolve()
        }
        const db = openDatabase()
        return new Promise((resolve, reject) => {
            db.transaction(
                (tx) => {
                    const query = `DELETE FROM ${GAMIFICATION_STORE_NAMES.GAME_PENDING_SEND} WHERE game_id = ? AND level_id = ?`
                    tx.executeSql(
                        query,
                        [game_id, level_id],
                        (_, result) => {
                            console.log(`Deleted game: ${game_id}`)
                            resolve(result)
                        },
                        (_, error) => {
                            console.error('Error deleting game', error)
                            reject(error)
                        },
                    )
                },
                (error) => {
                    console.error('Transaction error:', error)
                    reject(error)
                },
            )
        })
    }
}
export const GamificationServices = new gamificationServices(db)
